import React from "react";
import Header from "../components/commalax/header";
import AppRoutes from "../routes";
import Footer from "../components/commalax/footer";
import HomePage from "../pages/commalax/home_page";
import ContactPage from "../pages/commalax/contact_page";
import AboutPage from "../pages/commalax/about_page";
import ProductsPage from "../pages/commalax/products_page";

const CommalaxTemplate = () => {
  return (
    <div className="bg-[#f4d6d6]">
      <Header />
      <AppRoutes
        homePage={HomePage}
        contactPage={ContactPage}
        aboutPage={AboutPage}
        productsPage={ProductsPage}
      />
      <Footer />
    </div>
  );
};

export default CommalaxTemplate;
